export class Image{
    
}